import { useMemo, useState } from 'react'
import { parseMccs, parseMids } from './formUtils'

export const useRulesFields = ({ mccs, mids, partner }: { mccs: string[]; mids: string[]; partner: string | undefined }) => {
  const [mccsInputOverride, setMccsInputOverride] = useState<string | null>(null)
  const [midsInputOverride, setMidsInputOverride] = useState<string | null>(null)
  const [mccsSearch, setMccsSearch] = useState('')
  const [midsSearch, setMidsSearch] = useState('')
  const [mccsEditMode, setMccsEditMode] = useState(false)
  const [midsEditMode, setMidsEditMode] = useState(false)

  const mccsInput = mccsInputOverride ?? mccs.join('\n')
  const midsInput = midsInputOverride ?? mids.join('\n')

  const { mccs: parsedMccs, hasInvalid: hasInvalidMccs } = useMemo(() => parseMccs(mccsInput), [mccsInput])
  const { mids: parsedMids, hasInvalid: hasInvalidMids } = useMemo(() => parseMids(midsInput), [midsInput])
  const isRulesValid = !hasInvalidMccs && !hasInvalidMids && !!partner

  const isRulesChanged = useMemo(() => {
    const loadedMccsSet = new Set(mccs)
    const loadedMidsSet = new Set(mids)
    return (
      parsedMccs.length !== mccs.length ||
      parsedMccs.some((n) => !loadedMccsSet.has(n)) ||
      parsedMids.length !== mids.length ||
      parsedMids.some((m) => !loadedMidsSet.has(m))
    )
  }, [parsedMccs, parsedMids, mccs, mids])

  const filteredMccs = parsedMccs.filter((n) => n.includes(mccsSearch.trim()))
  const filteredMids = parsedMids.filter((mid) => mid.includes(midsSearch.trim()))

  return {
    isRulesValid,
    isRulesChanged,
    mcc: {
      loaded: mccs,
      input: mccsInput,
      search: mccsSearch,
      editMode: mccsEditMode,
      parsed: parsedMccs,
      filtered: filteredMccs,
      hasInvalid: hasInvalidMccs,
      onChange: (v: string) => setMccsInputOverride(v),
      onSearchChange: (v: string) => setMccsSearch(v),
      onEditModeToggle: () => setMccsEditMode((v) => !v),
    },
    mids: {
      loaded: mids,
      input: midsInput,
      search: midsSearch,
      editMode: midsEditMode,
      parsed: parsedMids,
      filtered: filteredMids,
      hasInvalid: hasInvalidMids,
      onChange: (v: string) => setMidsInputOverride(v),
      onSearchChange: (v: string) => setMidsSearch(v),
      onEditModeToggle: () => setMidsEditMode((v) => !v),
    },
  }
}
